module.exports = __webpack_public_path__ + "static/media/instagram-icon.82530bd9.png";